import Tr from 'translations/Translations';

const _TR_PREFIX = 'offer_status_';

export const OfferStatuses = {
    PLACED: 'placed',
    MODIFIED: 'modified',
    NO_OFFER: 'noOffer',
    MODIFIED_BY_OPERATOR: 'modifiedByOperator'
}

export const OfferStatusLabel = (status) => (Tr(_TR_PREFIX + status));